<template>
  <ion-page v-if="computedFilters && computedFilters.length > 0" :class="`${isDense ? 'dense' : ''}`" >
    <ion-header>
      <FormDataTableFilters
        ref="form-data-table-filters"
        :filters="computedFilters"
        :filtersModels="filtersModels"
        :search="search"
        :searchAsync="computedSearchAsync"
        @searching="search.value = $event"
        @filtersChange="filtersModels = $event"
        @filtersAsyncChange="filtersModelsAsync = $event"
        @clearFilters="clearFilters()"
        @clearSearch="clearSearch()"
      />
    </ion-header>
    <ion-content>
      <ion-card 
        v-for="(item, ix) in computedItems" :key="ix" 
        :class="item.invalidItem ? 'invalid-item' : item.warnedItem ? 'warned-item' : `inherit ${(item.selectedItem) ? 'selected-item' : ''} ${(item.outOfStock) ? 'out-of-stock-item' : ''}`"
        :style="{ margin: '10px 15px 10px 10px' }">
        <ion-card-header @click="showDetails(item)" :style="{ padding: '8px 8px 0 8px' }">
          <ion-list class="ion-no-padding ion-no-margin">
            <ion-item class="ion-no-padding ion-no-margin">
              <ion-img 
                v-if="item[imageHeader.value] && item[imageHeader.value].length > 0" 
                :src="item[imageHeader.value][0]"
                :style="{width: '15%', marginRight: '10px'}"
                slot="start"
                ></ion-img>
              <ion-card-subtitle> {{ item[titleHeader.value] }} - {{item[subTitleHeader.value]}}</ion-card-subtitle>
              <ion-icon slot="end" :size="isDense ? 'small': 'default'" :icon="(item.show) ? chevronUp : chevronDown"></ion-icon>
            </ion-item>
          </ion-list>
          
          <ion-list v-if="!item.show"  class="">
            <ion-row>
              <ion-col 
                v-for="(header, index) in allHeaders" 
                :key="index" 
                :size="`${header.mobile?.cols ? header.mobile.cols : '12' }`">
                <ion-label :style="{margin: 0}">
                  <span :style="{color: 'gray'}">
                    {{header.text}}:
                    <span :style="{color: isDark ? 'white' : 'black'}">{{ getFormatValue(header, item) }}</span>
                  </span>
                </ion-label>
              </ion-col>
            </ion-row>
          </ion-list>
        </ion-card-header>

        <template v-if="item.show">
          <ion-card-content 
            :class="item.invalidItem ? 'ion-no-padding invalid-header' : 'ion-no-padding'">

            <!-- <ion-card-subtitle v-if="!this.readonly" :style="{margin: '0 15px 7px', color: 'darkgray'}">Formulário:</ion-card-subtitle> -->
            <ion-list v-if="!this.readonly" :style="{padding: '0'}">
              <template v-for="(field, iy) in computedEditableHeadersData" :key="iy">
                <ion-item lines="none" v-show="!field.hide" 
                  :class="item.invalidItem && item.invalidField.header.value === field.value ? 'invalid-header box' : 'inherit box'"
                  :style="{'--min-height': 0}">
                  <section :style="{width: '100%', margin: '2px 0'}">
                    <ion-label position="floating" :style="{margin: '5px 8px 0 0', fontSize: '20px'}">{{ field.text }}</ion-label>
                    <div 
                      v-show="editing != `${ix}-${iy}`" 
                      @click="editingField({ix,iy})" 
                      :style="{height: '40px', lineHeight: '40px', boxSizing: 'content-box', fontSize: '22px', color: isDark ? 'white' : 'black'}"
                    >
                      {{getFormatValue(field, item)}}
                    </div>
                    <ion-input
                      v-show="editing == `${ix}-${iy}`"
                      :ref="`form-data-table__input--${ix}-${iy}`"
                      :color="item.invalidItem && item.invalidField.header.value === field.value ? 'danger' : 'undefined'"
                      :type="field.input ? field.input.type : ''"
                      v-model="item[field.value]"
                      :disabled="readonly || (typeof field.editable == 'function') ? !field.editable({item, formMaster}) : !field.editable"
                      @change="blurField({item, header: field, value: $event.target.value})"
                      @keydown.enter="editingField()"
                      @ionBlur="editingField()"
                      :style="{height: '40px', fontSize: '22px'}"
                    />
                      <!-- @click="$event.target.select()" -->
                  </section>
                  <section slot="end" :style="{margin: '15px 0 15px'}">
                    <ion-button 
                      v-if="field.input?.type == 'number'" 
                      color="danger" 
                      @click="item[field.value] = item[field.value] - 1; blurField({item, header: field, value: item[field.value]})"
                      size="small"
                      :style="{width: '50px', height: '50px', marginRight: '5px'}">
                      <ion-icon :icon="removeOutline"></ion-icon>
                    </ion-button>
                    <ion-button 
                      v-if="field.input?.type == 'number'" 
                      color="primary" 
                      @click="item[field.value] = item[field.value] + 1; blurField({item, header: field, value: item[field.value]})"
                      size="small"
                      :style="{width: '50px', height: '50px', marginRight: '5px'}">
                      <ion-icon :icon="addOutline"></ion-icon>
                    </ion-button>
                  </section>
                </ion-item>
              </template>
            </ion-list>

            <ion-button :color="item.invalidItem ? 'danger' : 'primary'"
              v-if="!readonly" @click="showDetails(item)" expand="block"
              :style="{margin: '0 10px'}">
              <ion-icon :icon="checkmarkOutline"></ion-icon> OK {{item.invalidItem ? '(Item com erros)' : ''}}
            </ion-button>

            <!-- <ion-card-subtitle :style="{margin: '10px 15px 0px', color: 'darkgray'}">Detalhes do item:</ion-card-subtitle> -->
            <ion-list :style="{padding: '0'}">
              <ion-item v-for="(field, index) in computedReadonlyHeadersData" :key="index">
                <ion-label :style="{margin: 0}">
                  <h6 :style="{color: 'gray'}">
                    {{field.text}}:
                    <ion-grid v-if="field.type == 'images'">
                      <ion-row>
                        <ion-col :size="(item[field.value].length > 1) ? 6 : 12" v-for="src in item[field.value]" :key="src">
                          <ion-img 
                            :src="src"
                          ></ion-img>
                        </ion-col>
                      </ion-row>
                    </ion-grid>
                    <span v-else :style="{color: isDark ? 'white' : 'black'}">
                      {{getFormatValue(field, item)}}
                    </span>
                  </h6>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>
        </template>

        <ion-card-subtitle v-if="item.invalidItem" :style="{ padding: '0 8px 1px' }">
          <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
          <template v-if="item.errorMessages && item.errorMessages.length > 0">
            <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="danger" v-for="(error, idx, key) in item.errorMessages" :key="key" v-html="`${error}`"></ion-text>
          </template>
        </ion-card-subtitle>

        <ion-card-subtitle v-if="item.warnedItem" :style="{ padding: '0 8px 1px' }">
          <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
          <template v-if="item.warnMessages && item.warnMessages.length > 0">
            <ion-text :style="{ display: 'block', marginBottom: '4px' }" color="warning" v-for="(warn, idx, key) in item.warnMessages" :key="key" v-html="`${warn}`"></ion-text>
          </template>
        </ion-card-subtitle>
        
        <ion-card-subtitle v-if="item.outOfStock" :style="{ padding: '0 8px 1px' }">
          <hr :style="{ height: '.25px', width: '100%' }" color="grey" />
          <ion-text :style="{ display: 'block' }" color="warning">Sem estoque</ion-text>
        </ion-card-subtitle>
      </ion-card>

      <!-- Loading -->
      <ion-grid v-if="loading" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label>Buscando itens</ion-label>
            <br/>
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- No Data -->
      <ion-grid v-else-if="computedItems && computedItems.length == 0" :style="{height: '50%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <ion-label color="danger" v-if="isSearched">A pesquisa por "<strong>{{ search.value }}</strong>" não retornou registros, confira os filtros selecionados.</ion-label>
            <ion-label color="danger" v-else-if="isFiltered">Os filtros selecionados não retornaram registros.</ion-label>
            <ion-label color="danger" v-else-if="SA7Filtered">A amarração cliente x produtos não retornou registros.</ion-label>
            <ion-label color="danger" v-else>Sem registros.</ion-label>
          </ion-col>
        </ion-row>
      </ion-grid>

      <!-- Scroll Next -->
      <ion-infinite-scroll
        @ionInfinite="loadData($event)"
        threshold="100px"
        id="infinite-scroll"
        ref="infiniteScroll"
        :disabled="readonly || disabledScroll">
        <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Buscando mais dados...">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ion-content>
  </ion-page>
</template>

<script>
import store from "../store";
import { createNamespacedHelpers } from "vuex";
const { mapState: registersState, mapActions: registersActions, mapMutations: registersMutations } = createNamespacedHelpers("registers");
import FormDataTableFilters from './FormDataTableFilters.vue'
import {  
  chevronDown, 
  chevronUp, 
  close,
  checkmarkOutline,
  addOutline,
  removeOutline
} from "ionicons/icons";
import {
  IonCard,
  IonContent,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonList,
  IonItem,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonLabel,
  IonInput,
  IonImg,
  // IonFooter,
  IonSpinner,
  IonButton,
  IonIcon,
  IonInfiniteScroll,
  IonPage,
  IonHeader,
  IonInfiniteScrollContent
  // IonModal,
} from "@ionic/vue";

export default {
  name: "FormDataTableV2MV2",
  components: {
    IonContent,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonText,
    IonSpinner,
    IonGrid,
    IonRow,
    IonCol,
    // IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
    IonInput,
    IonImg,
    IonHeader,
    // IonToggle,
    IonButton,
    IonIcon,
    // IonProgressBar,
    // IonFooter,
    IonPage,
    FormDataTableFilters,
    IonInfiniteScroll,
    IonInfiniteScrollContent
    // IonModal,
  },
  emits: ["validated", "setTotalize"],
  props: {
    props: {
      type: Object,
      default: () => {}
    },
    headers: Array,
    tableIdForeignValue: String,
    inputsMaster: Array,
    formMaster: Object,
    searchAsyncItems:  {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    tableSA7: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Array,
      default: () => [],
    },
    itemsDetails: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "teal",
    },
    dark: {
      type: Boolean,
      default: false,
    },
    exportXls: {
      type: Boolean,
      default: true,
    },
    xlsxName: {
      type: String,
    default: "itens",
    },
    filterItems: {
      type: Function,
      default: (item) => item,
    },
    user: Object,
    companySelected: Object,
    userRules: Array
  },
  data() {
    return {
      editing: null,
      editItem: {},
      editItemBollean: false,
      itemsProcessed: [],
      quantity: 0,
      imageHeader: {},
      titleHeader: {},
      subTitleHeader: {},
      allHeaders: [],
      errorMessages: [],
      headersData: [],
      loadingItems: true,
      loading: false,
      // loadedItems: [],
      showItems: false,
      isDisabled: false,
      maxLoadedItems: 20,
      disabledScroll: false,
      invalidItems: [],
      search: {
        value: "",
      },
      filtersModels: {
        invalidItem: false,
        warningCells: false
      },
      filtersModelsAsync: {},
      SA7: null,
      itemsDetailsEditable: [],
      sortBy: null,
      sortMod: null,
      itensPerPage: 20,
      andFilters: [],
      andOrFilters: [],
      orFilters: [],
      timeoutSearch: null,
      hasItens: false
    };
  },
  computed: {
    ...registersState(['registers']),
    computedSearchAsync () {
      return this.searchAsyncItems
    },
    isDark() { return store.$isDark },
    isDense() { return this.props.formDense },
    collection() { return this.props.tableCollection },
    subCollection() { return this.props.tableSubcollection },
    register() { 
      let register = (this.subCollection) ? `${this.collection}.${this.subCollection}` : this.collection 
      if (this.isSearched || this.isAscyncFiltered) { register = `${register}Filtered` }
      return register
    },
    filtersSubcollection() { return this.props.filtersSubcollection },
    orderBy() {
      let orderBy = this.props.orderSubcollection 
      if (typeof orderBy == 'string') orderBy = {field: orderBy, mod: 'asc'}
      if (this.sortBy) orderBy.field = this.sortBy
      if (this.sortMod) orderBy.mod = this.sortMod
      return orderBy
    },
    serverItemsLength() { return (this.isSearched) ? this.totalSearched : this.itemsTotal }, 

    computedHeadersData(){
      return this.headersData.filter(x => (typeof x.hide == 'function') ? !x.hide({readonly: this.readonly, formMaster: this.formMaster, user: this.user, userRules: this.userRules, companySelected: this.companySelected}) : !x.hide)
    },
    computedEditableHeadersData(){
      return this.computedHeadersData.filter(x => x.editable)
    },
    computedReadonlyHeadersData(){
      return this.computedHeadersData.filter(x => !x.editable || this.readonly)
    },
    computedItemsProcessed() {
      return this.itemsProcessed
    },
    headersMobile() {
      return this.computedHeadersData.filter((h) => h.mobile /*&& !h.mobile.justTotalize*/);
    },

    searchableHeaders() { return this.computedHeadersData.filter(x => x.searchable) },
    filterSearchable() { return this.computedHeadersData.filter(x => x.filterSearchable) },
    computedFilters() {
      const filters = this.headers.filter((x) => x.filterable === true);
      filters.forEach(el => {
        const ixH = this.headersData.findIndex(x => x.value === el.value)
        switch (el.filterType) {
          case 'switch':
            this.headersData[ixH].filter = (header, item) => {
              const validated = (item[header.value] || !this.filtersModels[el.value])
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        
          default:
            this.headersData[ixH].filterItems =  [ ...new Set(this.computedItemsProcessed.map(x => x[el.value])) ]
            this.headersData[ixH].filter = (header, item) => {
              if (!this.filtersModels[el.value])
                return true
              if (this.filtersModels[el.value].length === 0)
                return true

              const validated = this.filtersModels[el.value].findIndex(n => n == item[header.value]) > -1
              if (this.filtersModels.invalidItem)
                return validated /*&& !row.validated()*/
              return validated
            }
            break;
        }
      })
      
      if(!this.props?.hideFilters){
        filters.push({
          filterType: 'switch',
          filterLabel: 'Com aviso',
          value: 'warningCells',
          hide: this.readonly
        })
        filters.push({
          filterType: 'switch',
          filterLabel: 'Com erro',
          value: 'invalidItem',
          hide: this.readonly
        })
      }
      if (this.companySelected.groupCompany == 'decanter') {
        filters.push({
          filterType: 'switchAsync',
          filterLabel: 'Com estoque',
          invertLogic: true,
          value: 'outOfStock',
          hide: this.readonly
        })
      }
      return filters
    },
    totalize() {
      let totalize = null;
      totalize = [];
      this.headers
        .filter((x) => x.totalize)
        .forEach((elx) => {
          const total = (this.itemsDetailsEditable && this.itemsDetailsEditable.length > 0) ? this.itemsDetailsEditable
            .map((x) => (x[elx.value]*1))
            .reduce((acc, cur) => acc + cur): 0;
          const prefix = elx.prefix ? elx.prefix + " " : "";
          const suffix = elx.suffix ? " " + elx.suffix : "";
          if (elx.totalizeSelecteds){
            const selecteds = this.itemsDetailsEditable
              .filter((x) => x[elx.value])
              .length
            totalize.push({
              mobile: true,
              label: elx.totalizeSelectedsLabel || elx.totalizeLabel || elx.text,
              text: selecteds,
              value: `${elx.value}Selecteds`,
            });
          }
          totalize.push({
            label:  elx.totalizeLabel || elx.text,
            original: total,
            mobile: elx.mobile,
            text:
              prefix +
              total.toLocaleString("pt-br", {
                minimumFractionDigits: elx.precisionText,
                maximumFractionDigits: elx.precisionText,
              }) +
              suffix,
            value: elx.value,
          });
        });

      const totalizeMaster = this.props.totalizeMaster
      if (totalizeMaster && totalizeMaster.length > 0) {
        for (const [ix, elx] of totalizeMaster.entries()) {
          const original = elx.original.includes('=>') ? eval(elx.original)({totalize, item: this.formMaster}) : elx.original
          const prefix = elx.prefix ? elx.prefix + " " : "";
          const suffix = elx.suffix ? " " + elx.suffix : "";
          totalize.push({
            label: elx.label,
            original,
            text:
              prefix +
              original.toLocaleString("pt-br", {
                minimumFractionDigits: elx.precisionText || 2,
                maximumFractionDigits: elx.precisionText || 2,
              }) +
              suffix,
            value: elx.value,
            hide: elx.hideTotalize || false
          });
        }
      }
      return totalize;
    },
    items() {
      let items = []
      if (this.readonly) {
        items = store.$_.cloneDeep(this.itemsDetailsEditable)
      } else {
        items = this.registers[this.register]
        if (!this.tableIdForeignValue || !items || !items.length > 0) return []
      
        // Removendo itens duplicados, deixando a data de vigencia ativa mais recente
        if (this.subCollection == 'DA1') {
          const now = store.$moment(new Date()).format("YYYYMMDD")
          items = items
            // Filtra itens apenas dentro da vigencia
            .filter(x => x.DA1_DATVIG <= now)
            // Ordena itens pelo código e vigencia, DESC
            .sort((a, b) => {
              if (a.DA1_CODPRO+a.DA1_DATVIG > b.DA1_CODPRO+b.DA1_DATVIG) {return -1}
              else if (a.DA1_CODPRO+a.DA1_DATVIG < b.DA1_CODPRO+b.DA1_DATVIG) {return 1}
              else {return  0}
            })
            // Remove duplicados com base no código
            .filter((value, index, self) =>
              index === self.findIndex((t) => (
                t.DA1_CODPRO === value.DA1_CODPRO
              ))
            )
            // Retorna a ordenação padrão
            .sort((a, b) => {
              if (a[this.props.orderSubcollection] < b[this.props.orderSubcollection]) {return -1}
              else if (a[this.props.orderSubcollection] > b[this.props.orderSubcollection]) {return 1}
              else {return  0}
            })
        }
        
        // Mapeando preenchimento
        items = items.map(item => {
          let filteredItem = {}
          this.props.headersDetails.forEach(header => {
            let fill = (header.fill && item[header.fill]) ? item[header.fill] : null
            if (header.type == 'integer' && typeof fill == 'string') { fill = parseInt(fill) }
            if (header.type == 'float' && typeof fill == 'string') { fill = parseFloat(fill) }
            filteredItem[header.value] = (fill) ? fill : item[header.value]
            
            if (typeof filteredItem[header.value] === 'undefined') {
              filteredItem[header.value] = header.default
            }
          })
          return filteredItem
        })
      
        // Filtro SA7
        if (this.SA7Filtered) {
          const SA7Cod = this.SA7.map(x => x.A7_PRODUTO.trim())
          items = items.filter(x => SA7Cod.includes(x.DA1_CODPRO.trim()))
            .map(x => ({...x, ...this.SA7.find(y => y.A7_PRODUTO.trim() == x.DA1_CODPRO.trim())}))
        }

        // Itens rascunho
        if (this.itemsDetailsEditable.length > 0) {
          // Adicionando items de rascunho que não existem na listagem carregada
          if (!this.isSearched) {
            for (const itemsDetails of this.itemsDetailsEditable) {
              const ix = items.findIndex(_item => this.props.headersDetails.filter(h => h.identifier).every(h => itemsDetails[h.value] == _item[h.value]))
              if (ix == -1) { items.push(itemsDetails) }    
            }
          }
    
          // Preenchendo tabela de items com itens de rascunho
          items = items.map(item => ({...item, ...this.itemsDetailsEditable.find(_item => this.props.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value]))}) || item)
        }
      }
      
      return items
    },
    SA7Filtered() {
      return this.SA7 && this.SA7.length > 0
    },
    isSearched() {
      return !!(this.search && this.search.value)
    },
    isAscyncFiltered() {
      return !!(this.filtersModelsAsync && this.filtersModelsAsync.length > 0)
    },
    isFiltered() {
      if (this.search && this.search.value && this.search.value.length > 0)
        return true
      
      return Object.entries(this.filtersModels)
        .some(([_, model]) => {
          if (Array.isArray(model) && model.length > 0)
            return true
          if (typeof model == "boolean" && model)
            return true
          return false
        })
    },
    computedItems() {
      const someItemExpanded = this.computedItemsProcessed.some(i => i.show)
      const filters = Object.entries(this.filtersModels).filter(([key,value]) => Array.isArray(value) && value.length === 0 ? false : true).map(([key, value]) =>  ({header: key, value}) )
      const itemsShowed = this.computedItemsProcessed.filter(i => i.show || !someItemExpanded)

      const itemsReturned = (!this.isFiltered) ? itemsShowed : itemsShowed.filter(i => {
        const validFilters = filters.every(f => {
          const filter = this.computedFilters.find(x => x.value == f.header)
          if (typeof f.value === 'boolean') {
            return !f.value || ((filter && filter.invertLogic) ? !i[f.header] : i[f.header])
          } else if (typeof i[f.header] === 'undefined') { 
            return true
          } else {
            return f.value.some(filter => (filter+'').trim().toLowerCase() === (i[f.header]+'').trim().toLowerCase())
          }
        })
        // const searcher = this.headersMobile.map(hm => (i[hm.value] + '').toLowerCase().trim()).join('')
        return validFilters // && searcher.includes(this.search.value.toLowerCase().trim())
      })
      
      return itemsReturned
    },
    validated() {
      return !(this.computedItemsProcessed.filter(i => i.invalidItem).length > 0) && this.computedItemsProcessed.filter(this.filterItems).length > 0
    },
  },
  watch: {
    tableIdForeignValue(val, oldVal) {
      if (oldVal != null) { this.resetFormDataTable() }
      this.getTableItems({id: val})
    },
    formMaster: {
      handler(val, oldVal) {
        // Recomputa a table caso algum campo do Form afete calculo da celula
        const inputComputedDetails = this.inputsMaster.filter(x => x.computedDetails)
        for (const input of inputComputedDetails) {
          if (this.hasItens && val[input.value] !== oldVal[input.value]) {
            this.computeItems()
          }
        }
      },
      deep: true
    },
    itemsDetails(items) {
      this.itemsDetailsEditable = items
      if (this.readonly) { this.computeItems() }
    },
    filtersModelsAsync: {
      handler(val, oldVal) {
        if (val) {
          this.filterAsync(val)
        } else {
          this.computeItems()
        }
      },
      deep: true
    },
    search: {
      handler(val, oldVal) {
        this.closeAllCards()
        if (val.value) {
          this.loading = true
          this.itemsProcessed = []
          
          this.resetRegister(this.register)
          if (this.timeoutSearch) { clearTimeout(this.timeoutSearch) }
          
          this.timeoutSearch = setTimeout(() => {
            this.timeoutSearch = null
            this.orFilters = []
            // this.andFilters = []
            
            // Replace especial chars
            let search = val.value.replace(/\+|\/|\.|\(|\)/g, '')
            
            // Busca segmentada
            if (search.includes('%%')) {
              search = search.split('%%')
              for (let ix = 1; ix < search.length; ix++) {
                const el = search[ix]
                const header = this.filterSearchable[ix-1]
                if (el && header) {
                  this.andFilters.push({
                    key: header.fill || header.value,
                    operator: 'like',
                    value: el.trim()
                  })
                }
              }
              search = search[0].trim()
            }

            for (const header of this.searchableHeaders) {
              let operator = 'like'
              if (header.andSearchable) { operator = 'string_contains' }
              else if (header.wordSearchable) { operator = 'string_contains_word' }
              
              this.orFilters.push({
                key: header.fill || header.value,
                operator,
                value: search
              })
            }

            this.getTableItems({resetRegister: true})
          }, 1500)
        } else {
          // this.getTableItems({resetRegister: true})
          this.computeItems()
        }
      },
      deep: true
    },
  },
    methods: {
    ...registersMutations(['resetRegister']),
    ...registersActions(["get", "getById", "getOnMongo", "nextOnMongo", "showToast", "getGpEmpresa", "getFilial"]),

    ultPedido() {
      if (!this.formMaster.C5_CLIENTE || !this.formMaster.C5_LOJACLI) {
        this.showToast({ 
          message: 'Selecione o cliente', 
          color: "error", 
          duration: 4000,
        })
      } else {
        this.showToast({ 
          message: 'Carregar itens do último pedido?', 
          color: "primary", 
          duration: 4000,
          buttons: [
            {
              text: 'Não',
              role: 'cancel',
              handler: () => {
              },
            },
            {
              text: 'Sim',
              handler: () => {
                this.loadUltPedido()
              },
            }
          ]
        })
      }
    },

    async loadUltPedido() {
      // Busca último pedido do cliente
      this.computedItems
      let SC5 = await this.get({
        collection: 'SC5', 
        filters: [
          {key: "C5_CLIENTE", operator: '==', value: this.formMaster.C5_CLIENTE},
          {key: "C5_LOJACLI", operator: '==', value: this.formMaster.C5_LOJACLI},
        ], 
        orderBy: [
          {key: "lifeControl.createdAt", mod: 'desc'},
        ],
        limit: 1,
        forceOrder: true,
        disableIntFilters: !!(this.user.superAdmin || this.user.companies[this.companySelected.groupCompany].admin),
        forceFilter: true,
        setRegister: false
      })
     
      // Se tiver último pedido carrega os itens
      if (SC5 && SC5[0] && SC5[0].id) {
        // Busca itens
        const collection = `customers/${this.companySelected.groupCompany}/SC5`
        const ref = store.$db().collection(collection).doc(SC5[0].id).collection('SC6')
        const SC6 = await this.get({collection, ref, limit: 1000})
      
        // Busca itens não carrregados na table
        let gpEmpresa = await this.getGpEmpresa('DA0')
        gpEmpresa = gpEmpresa.slice(0, -1)
        const filial = await this.getFilial('DA0')
        const table = gpEmpresa+filial+this.tableIdForeignValue
        const ids = SC6.map(x => x.C6_PRODUTO).filter(x => !this.computedItems.some(y => y.C6_PRODUTO == x))
        let DA1 = []
        if (ids && ids.length > 0) {
          const chunks = []
          for (let ix = 0; ix < ids.length/10; ix++) {
            chunks.push(ids.slice(ix*10, (ix+1)*10))
          }
          for (const el of chunks) {
            DA1 = await this.get(
              {
                register: this.register, 
                collection: `${this.collection}/${table}/${this.subCollection}`, 
                filters: [{
                  key: 'DA1_CODPRO', 
                  operator: 'in', 
                  value: el
                }],
                limit: el.length,
                disableIntFilters: true,
                // setRegister: false,
                forceFilter: true
              }
            )
          }
        }

        // Atualiza itens
        await this.computeItems()
        
        // items = items.concat(DA1.map(x => x.C6_PRODUTO = x.DA1_CODPRO))
        for (const itemSC6 of SC6) {
          const item = this.computedItems.find(_item => {
            return this.props.headersDetails
              .filter(h => h.identifier)
              .every(h => itemSC6[h.value] == _item[h.value])
          })
          for (const h of this.computedEditableHeadersData) {
            this.blurField({item, header: h, value: itemSC6[h.value]})
          }
        }

        this.showToast({ 
          message: 'Itens importado com sucesso', 
          color: "success", 
          duration: 2000,
        })
      } else {
        this.showToast({ 
          message: 'Último pedido não encontrado', 
          color: "error", 
          duration: 2000,
        })
      }
    },

    filterAsync({andFilters, andOrFilters, orFilters} = {}) {
      this.closeAllCards()
      this.loading = true
      this.itemsProcessed = []
      
      this.resetRegister(this.register)
      if (this.timeoutSearch) { clearTimeout(this.timeoutSearch) }
      
      this.timeoutSearch = setTimeout(() => {
        this.timeoutSearch = null
        this.andFilters = []
        this.andOrFilters = []
     
        if (andFilters) this.andFilters = this.andFilters.concat(andFilters);
        if (andOrFilters) this.andOrFilters = this.andOrFilters.concat(andOrFilters);
        
        this.getTableItems({resetRegister: true})
      }, 1500)
    },
    editingField({ix, iy} = {}) {
      if (ix == undefined || iy == undefined) return this.editing = null
      this.editing = `${ix}-${iy}`
      this.$nextTick(() => {
        this.getInput(ix,iy).setFocus()
      });
    },

    getInput(ix,iy) {
      return this.$refs[`form-data-table__input--${ix}-${iy}`][0].$el
    },

    closeAllCards() {
      this.itemsProcessed = this.itemsProcessed.map(x => {x.show = false; return x})
      this.itemsDetailsEditable = this.itemsDetailsEditable.map(x => {x.show = false; return x})
    },

    async getTableItems({id = this.tableIdForeignValue, resetRegister = true} = {}) {
      this.hasItens = false
      if (this.readonly) {
        this.loading = false
        this.computeItems()
        return
      }
      if (!id) return
      
      this.loading = true
      const res = await this.getOnMongo({
        register: this.register, 
        collection: this.collection, 
        subCollection: this.subCollection,
        id,
        filters: [...this.andFilters, ...this.filtersSubcollection], 
        notMounted: true,
        andOrFilters: this.andOrFilters,
        orFilters: this.orFilters,
        orderBy: this.orderBy, 
        limit: this.itensPerPage,
        getTotal: true,
        getFirestore: true,
        resetRegister,
      }).catch(err => this.loading = false)
      
      if (this.isSearched && res && res.meta && res.meta.total) { this.totalSearched = res.meta.total }
      else if (res && res.meta && res.meta.total) { this.itemsTotal = res.meta.total }
      else { this.loading = false }
     
      if (this.subCollection == 'DA1' && this.tableSA7) {
        // Verifica se existe amarração x cliente (SA7)
        this.getSA7()
      }
      
      this.computeItems()
      this.hasItens = true
      this.loading = false
      return res
    },

    resetFormDataTable () {
      this.resetRegister(this.register)
      this.search.value = null
      this.orFilters = []
      this.andFilters = []
      this.itemsDetailsEditable = []
      this.filtersModels = {
        invalidCells: false,
        warningCells: false,
      }
    },

    resetTableItems () {
      this.disabledScroll = false
      this.loading = false
    },

    clearSearch() {
      this.resetTableItems()
      if (this.filtersModelsAsync) {
        this.orFilters = []
        this.filterAsync(this.filtersModelsAsync)
      }
    },

    clearFilters() {
      this.filtersModelsAsync = null
      this.andFilters = []
      this.andOrFilters = []
      this.orFilters = []
      this.clearSearch()
      // this.resetTableItems()
    },

    dispatchClearFilters() {
      this.$refs['form-data-table-filters'].clearFilters()
    },

    
    async getSA7() {
      const item = this.$refs.formMaster.getModel()
      if (item && item.SA1 && item.SA1.A1_COD) {
        this.SA7 = this.get({
          collection: 'SA7', 
          filters: [
            {key: "A7_CLIENTE", operator: '==', value: item.SA1.A1_COD},
            {key: "A7_LOJA", operator: '==', value: item.SA1.A1_LOJA},
          ], 
          limit: 9999,
          forceFilter: true,
          setRegister: false
        })
      }
    },

    getModel() {
      const itemsProcessed = this.computedItemsProcessed.map(item => {
        this.computedHeadersData.forEach(header => {
          if (header.type == 'integer') {
            item[header.value] = parseInt(item[header.value])
          } else if (header.type == 'float') {
            item[header.value] = parseFloat(item[header.value])
          }
        })
        return item
      })
      return itemsProcessed
    },
    getTable() {
      return this.computedItemsProcessed.map(item => {
        let itemTable = {}
        for (let header of this.computedHeadersData) {
          itemTable[header.value] = this.getFormatValue(header, item)
        }
        return itemTable
      })
    },
    showDetails(item) {
      this.editing = null
      item.show = !item.show;
      const ix = this.itemsDetailsEditable.findIndex(_item => this.props.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value]))
      if (ix > -1) {
        this.itemsDetailsEditable[ix].show = item.show
      }    
      this.disabledScroll = item.show;
    },
    validate() {
      const allValidations = this.computedItemsProcessed.filter(this.filterItems).every(item => 
        this.computedHeadersData.filter(header => header.validation).every(header => 
          header.validation.every((f) => {
            const validated = f(item);
            if (typeof validated == "string") {
              this.errorMessages.push(validated)
              return false;
            } else {
              return validated;
            }
          })
        )
      )

      return allValidations;
    },
    getTotalize() {
      return this.totalize;
    },
    getMaskedValue({header, item}) {
      const value = item[header.value] ? item[header.value] : header.default ? header.default : null
      if (typeof value === 'null' || typeof value === 'NaN') return ''

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const prefix = header.prefix ? header.prefix + " " : "";
      const suffix = header.suffix ? " " + header.suffix : "";

      return prefix + maskedValue + suffix;
    },
    async fetchFiltersCollections() {
      await Promise.all(
        this.filters.map(async (filter) => {
          if (filter.method && filter.method.collectionName) {
            const response = await this.get({
              collection: filter.method.collectionName,
              register: filter.method.collectionName,
              orderBy: "indice",
            });
            filter.method.values = response.map(
              (item) => item[filter.method.collectionField]
            );
            return response;
          }
          return Promise.resolve();
        })
      );
    },
    async blurField({ item, value, header }) {
      item = await this.process({ item, value, header }) 
      this.setitemsDetailsEditable(item)
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },
    setitemsDetailsEditable(item) {
      const ix = this.itemsDetailsEditable.findIndex(
        _item => this.props.headersDetails.filter(h => h.identifier).every(h => item[h.value] == _item[h.value])
      )
      if (ix > -1) {
        this.itemsDetailsEditable[ix] = item
      } else {
        this.itemsDetailsEditable.push(item)
      }
    },
    async process({ item, value, header }) {
      item = this.setValue({item, header, value})
      
      this.warnField({header, item})
      
      this.validateField({header, item})

      // Array com os dependentes diretos do header alterado.
      // Eliminando a possibilidade do elemento ser dependente dele mesmo na montagem da chain
      let ix = 0
      const headers = this.headers.filter(h => h.value != header.value).map(x => {x.ix = ix; ix++; return x})
      const directDependentAttributes = this.getDependentAttributes(header, headers)
     
      // Monta o resto da chain com base nas primeiras dependencias
      let dependencyChain = this.getDependencyChain(directDependentAttributes, headers)
   
      // Reordena o chain para garantir a ordem de execução com base na ordenação original das colunas
      dependencyChain = dependencyChain.reduce((acc,arr) => [...acc, ...arr.filter(el => !acc.includes(el))], []).sort((a, b) => a.ix - b.ix)
      for (const header of dependencyChain) {
        item = await this.computeItem({item, header})
      }
      return item
    },
    /**
     * Retorna um array de headers que dependem *diretamente* do `header` passado no primeiro parâmetro
     */
    getDependentAttributes (header, headers) {
      return headers.filter(h => h.dependents && h.dependents.includes(header.value))
    },
    /**
     * Retorna uma cadeia de headers que são dependentes dos headers passados no primeiro argumento.
     * A ordem dos elementos no array indicam o grau de dependência dos headers.
     */
    getDependencyChain(dependents, headers, dependencyChain = []) {
      if (dependents.length == 0)
        return dependencyChain

      const filteredHeaders = headers.filter(h => !dependents.includes(h))
      const newDependents = dependents
        .map(h => this.getDependentAttributes(h, filteredHeaders))
        .reduce((acc,arr) => [...acc, ...arr.filter(el => !acc.includes(el))], [])

      return this.getDependencyChain(newDependents, filteredHeaders, [...dependencyChain, dependents])
    },

    async computeItems(){
      // Seta Default
      let items = this.items.map(item => {
        for (const header of this.headers) {
          const value = item[header.value] != undefined
            ? item[header.value]
            : 'default' in header
              ? header.default
              : null

          item[header.value] = value
        }
        if (item.invalidItem == 'undefined') item.invalidItem = false
        return item
      })

      // Processa items
      this.itemsProcessed = items
      for (let [ix, item] of this.items.entries()) {
        for (const header of this.headers.filter(h => h.computeFirst !== false)) {
          if (item[header.value] != undefined && item[header.value] != null) {
            // item = await this.process({ item, value: item[header.value], header }) 
            item = await this.computeItem({item, header})
          }
        }
        if (this.readonly) { 
          this.setitemsDetailsEditable(item) 
        }
        items[ix] = item
      }
      this.itemsProcessed = []
      this.itemsProcessed = items
      this.loadingItems = false
      this.$emit('validated', this.validated)
      this.$emit('setTotalize', this.totalize)
    },

    async computeItem({item, header}) {
      if (!header || !header.dependents || !header.computed) return item
      const itemDependent = this.getDependentsItem({item, header})
      const computedValue = await header.computed({item: itemDependent, value: header.value, readonly: this.readonly}) 
      // console.info('computeItem', header.value, computedValue, {header, itemDependent, formMaster: this.formMaster})
      return this.setValue({item, header, value: computedValue,readonly: this.readonly})
    },

    getDependentsItem({header, item}) {
      return header.dependents.reduce((acc, dependent) => {
        const value = (dependent in item) ? item[dependent] : this.formMaster[dependent]
        return { ...acc, [dependent]: value }
      }, {})
    },

    setValue({value, item, header}, { validate = true, set = true, mask = true, verbose = true } = { validate: true, set: true, mask: true, verbose: true }) {
      if (value == null) {
        if (verbose)
          console.warn(`${header.value} "value" is null`)

        item[header.value] = value

        if (header.required) {
          this.validated = false
          this.errorMessages.push('Campo obrigatório')
        }
        return item
      } 

      const valueBkp = value
      if(header.type == 'text' || header.type == 'object'){
        set = false
      }
      if (header.type == 'integer') {
        value = parseInt(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          return item
        }
      } else if (header.type == 'float') {
        value = parseFloat(value)
        if (isNaN(value)) {
          if (verbose) {
            console.warn(`${header.value} "value (${valueBkp})" is NaN`)
          }
          return item
        } 
        value = this.fixPrecision(value, header.precisionValue)
      }
      if (set) {
        item[header.value] = header.set ? this.fixPrecision(header.set({value, item}, this.formMaster), header.precisionValue) : value
      } else {
        item[header.value] = value
      }
      
      if (!this.readonly) {
        // Marca selecionados
        item.selectedItem = item.C6_QTDVEN > 0

        // Marca estoque Decanter
        if (this.companySelected.groupCompany == 'decanter') {
          let stockField = null
          switch (this.companySelected.M0_CODFIL) {
            case '0201':
              stockField = 'B2_SALDO0201'
              break;
            case '0202':
              stockField = 'B2_SALDO0202'
              break;
            case '0203':
              stockField = 'B2_SALDO0203'
              break;
            case '0204':
              stockField = 'B2_SALDO0204'
              break;
            default:
              // M0_CODIGO '01'
              stockField = 'B2_QATU'
              break;
          }
          let stockFieldFil = null
          switch (this.companySelected.M0_CODFIL) {
            case '0102':
              stockFieldFil = 'B2_SLDFPOL'
              break;
            case '0103':
              stockFieldFil = 'B2_SLDSP3'
              break;
            case '0104':
              stockFieldFil = 'B2_SLDBNU'
              break;
            case '0105':
              stockFieldFil = 'B2_SLDSP5'
              break;
            case '0107':
              stockFieldFil = 'B2_SLDRJ7'
              break;
          }
          item.outOfStock = item[stockField] < 1 && (!stockFieldFil || item[stockFieldFil] < 1)
        }
      }

      return item
    },

    validateField({item, header}) {
      const { validation = [] } = header
      if (validation && validation.length > 0) item.errorMessages = []
      return validation.every(f => {
        const validated = f({...this.formMaster, ...item})
        if (typeof validated == 'string') {
          item.invalidField = { header }
          item.invalidItem = true
          item.errorMessages.push(validated)
          return false
        } else {
          item.invalidField = validated ? { header } : null
          item.invalidItem = !validated
          return validated
        }
      })
    },

    warnField({header, item}) {
      const { warning = [] } = header
      if (warning && warning.length > 0) item.warnMessages = []
      for (const f of warning) {
        const warned = f({...this.formMaster, ...item})
        if (typeof warned == 'string') {
          item.warnedField = { header }
          item.warnedItem = true
          item.warnMessages.push(warned)
        } else {
          item.warnedField = warned ? { header } : null
          item.warnedItem = warned
        }
      }
    },

    fixPrecision(value, precision = 4) {
      if (!Number.isFinite(value)) {
        return NaN
      }

      let fixed = value
      if (!Number.isInteger(fixed)) {
        let [integerPart, mantissa] = fixed.toString().split('.')
        
        if (mantissa && mantissa.length > precision) {
          const balanceDigit = parseInt(mantissa[precision])
          if (balanceDigit >= 5) {
            let fix = (parseInt(`${integerPart}${mantissa.slice(0, precision)}`) + 1).toString()
            fix = fix.padStart(integerPart.length+precision, '0')
            
            integerPart = fix.slice(0, fix.length - precision)
            mantissa = fix.slice(-precision)
          } else {
            mantissa = mantissa.slice(0, precision)
          }
          fixed = parseFloat(integerPart + '.' + mantissa)
        }
      }

      return fixed
    },
    getFormatValue(header, item) {
      let value = item[header.value]
      const prefix = header.prefix
        ? header.prefix + ' '
        : ''

      if (typeof value === 'undefined' || value === null) {
        if (typeof header.default !== 'undefined') {
          value = header.default
        } else if (header.type == 'float' || header.type == 'integer') {
          value = 0
        } else {
          value = ''
        }
      }

      const maskedValue = header.type == 'float' || header.type == 'integer'
        ? value.toLocaleString('pt-br', { minimumFractionDigits: header.precisionText, maximumFractionDigits: header.precisionText })
        : value

      const suffix = header.suffix
        ? ' ' + header.suffix
        : ''

      return prefix + maskedValue + suffix
    },
    loadData(event) {
      this.nextOnMongo({ register: this.register, limit: this.itensPerPage })
        .then(res => { 
          if (!res) { this.disabledScroll = true } 
          else { this.computeItems() }
        })
        .catch(err => this.disabledScroll = true)
        .finally(() => event.target.complete())
    },
  },
  setup() {
    return {
      chevronDown,
      chevronUp,
      close,
      checkmarkOutline,
      addOutline,
      removeOutline
    };
  },
  created() {
    this.headersData = this.headers
    this.fetchFiltersCollections()
    this.titleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "title"
    );
    this.subTitleHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "subTitle"
    );
    this.imageHeader = this.headersMobile.find(
      (hm) => hm.mobile.type === "images"
    ) || {} 
    this.allHeaders = this.headersMobile
      .filter((hm) => hm.mobile.type === "all")
      .sort((h1, h2) => {
        if (h1.mobile.horizontalPosition > h2.mobile.horizontalPosition)
          return 1;
        if (h1.mobile.horizontalPosition < h2.mobile.horizontalPosition)
          return -1;
        return 0;
      });
  },
};
</script>

<style scoped>
  .row-margin-bottom {
    margin-bottom: 8px;
  }
  .warned-item, .warned-header, .out-of-stock-item {
    border: 1pt solid var(--ion-color-warning);
  }
  .selected-item, .selected-header {
    border: 1pt solid var(--ion-color-success);
  }
  .invalid-item, .invalid-header {
    border: 1pt solid var(--ion-color-danger);
  }
  .invalid-header *:not(ion-button, ion-icon) {
    color: var(--ion-color-danger)
  }
  ion-input {
    font-family: Open Sans,sans-serif!important;
  }
  .box {
    border-color: rgba(0, 0, 0, 0.2);
    border-width: thin;
    border-style: solid;
    border-radius: .5em;
    padding: 0;
    margin: 0 10px 10px;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    font-family: Open Sans,sans-serif!important;
    color: rgba(0, 0, 0, 0.671);
  }
  .ion-page.dense :deep(ion-card-header) ion-col {
    padding: 2px 5px 2px 0px;
  }
  .ion-page.dense :deep(ion-card-header) ion-item {
    min-height: 0;
    height: 20px;
  }
  .ion-page.dense :deep(ion-card-header) ion-item::part(native) {
    min-height: 0!important;
  }
  .ion-page.dense ion-card-header {
    font-size: 0.8em;
  }
  .ion-page.dense ion-card-subtitle {
    font-size: 0.6em;
  }
  .ion-page.dense :deep(ion-card-header) .item-inner {
    padding: 0!important;
  }
  .ion-page.dense :deep(ion-card-header) ion-icon {
    margin: 0;
  }
</style>